import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';
import data from '../../data/pathway15states.json';
const { opening_shift: os, page_copy: copy } = data;

const Row = ({ items, tone, testId }) => (
  <ol className="flex flex-col items-center gap-1 min-[701px]:flex-row min-[701px]:justify-center min-[701px]:gap-3" data-testid={testId}>
    {items.map((t, i) => (
      <React.Fragment key={t}>
        <li className={`text-center font-extrabold leading-tight tracking-tight text-gray-900 ${tone === 'big' ? 'text-2xl sm:text-3xl min-[701px]:text-[clamp(1.1rem,2vw,1.9rem)] min-[701px]:whitespace-nowrap' : 'text-xl sm:text-2xl'}`}>{t}</li>
        {i < items.length - 1 && <li aria-hidden className="text-teal-600 flex"><ArrowDown size={20} className="min-[701px]:hidden" /><ArrowRight size={22} className="hidden min-[701px]:block" /></li>}
      </React.Fragment>
    ))}
  </ol>
);

export const StagesIntro = () => (
  <header className="text-center space-y-5 min-w-0" data-testid="p15-intro">
    <p className="text-xs font-bold uppercase tracking-widest text-teal-700">{copy.eyebrow} · Prepare Now</p>
    <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight" data-testid="p15-heading">{copy.heading}</h1>
    <p className="text-sm text-gray-600 max-w-2xl mx-auto">{copy.intro}</p>
    <Row testId="p15-work-stages" tone="big" items={os.work_sequence} />
    <ul className="flex flex-col min-[701px]:flex-row justify-center gap-1 min-[701px]:gap-6 text-[11px] font-bold uppercase tracking-widest text-gray-500" data-testid="p15-work-badges">{os.work_stage_badges.map((b) => <li key={b}>{b}</li>)}</ul>
    <div className="inline-block max-w-full rounded-2xl border border-teal-100 bg-white/80 backdrop-blur px-5 py-3">
      <p className="text-[11px] font-bold uppercase tracking-widest text-gray-500 mb-1">{os.technology_sequence_label}</p>
      <Row testId="p15-capability-stages" tone="small" items={os.technology_sequence} />
    </div>
    <p className="text-sm text-gray-700 max-w-2xl mx-auto" data-testid="p15-intro-copy">{os.plain_explanation} {os.concept_note}</p>
    <p className="text-sm font-semibold text-gray-900 max-w-2xl mx-auto">{os.action_line}</p>
  </header>
);
